export default __webpack_public_path__ + "static/bsfi-quiz-n-win-15a2da5daf7be5534eade9e08e1e3dfc.gif";